/**
 * Maps backend permission errors to a user-facing message.
 *
 * The backend answers with the standard envelope
 * `{ success:false, status, title, msg, type, ...extras }` where `extras`
 * may carry one of the key lists below. The first matching list wins.
 */
const MENSAJES_POR_EXTRA = [
  ["claves_desconocidas", "Acciones inexistentes: "],
  ["claves_no_habilitadas", "No habilitadas en el plan: "],
  ["claves_no_otorgables", "Tu rol no tiene estas acciones, no podés otorgarlas: "],
  ["claves_faltantes", "El rol quedaría sin poder administrar roles. Volvé a marcar: "],
  ["claves_bloqueadas", "Denegadas al usuario, no se pueden otorgar: "],
  ["rutas_desconocidas", "Rutas desconocidas: "],
  ["menus_desconocidos", "Menús desconocidos: "],
];

const MENSAJE_CATALOGO_NO_DISPONIBLE =
  "Catálogo de permisos no disponible. Intentá de nuevo en unos minutos.";

export const MENSAJE_GENERICO = "Error inesperado";

/**
 * @param {*} error - Axios error (or anything thrown)
 * @returns {{ mensaje: string, claves: string[] }}
 */
export function mensajeDeError(error) {
  const status = error?.response?.status;
  const data = error?.response?.data || {};

  const extra = MENSAJES_POR_EXTRA.find(([campo]) => Array.isArray(data[campo]) && data[campo].length);
  if (extra) {
    const [campo, prefijo] = extra;
    const claves = data[campo].map(String);
    return { mensaje: prefijo + claves.join(", "), claves };
  }

  if (status === 503) {
    return { mensaje: MENSAJE_CATALOGO_NO_DISPONIBLE, claves: [] };
  }

  return { mensaje: data.msg || data.title || error?.message || MENSAJE_GENERICO, claves: [] };
}
